import './incidentListContextMenu.scss'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import contextMenuImage from './../../../../../common/images/context-menu/contextMenuLight.png'
import { useMsal } from '@azure/msal-react'
import IEntityIncident from './../../../../../common/interfaces/entityIncident/IEntityIncident'
import CreateIncidentAction from '../../../../../common/services/action/IncidentActionService'
import { useState } from 'react'
import IncidentCancellationContextMenuPart from '../../../../../common/components/incidentCancellation/IncidentCancellationContextMenuPart'
import IApplicationSettings from '../../../../../common/interfaces/applicationSettings/IApplicationSettings'
import IncidentCollectionRequestType from '../../../../../common/types/IncidentCollectionRequestType'
import CreateIncidentCancellation from '../../../../../common/services/incidentCancellation/IncidentCancellationService'
import ICustomer from '../../../../../common/interfaces/customer/ICustomer'
import ICustomerIncidentAction from '../../../../../common/interfaces/customer/ICustomerIncidentAction'
import ActionIsAllowedOnIncidents from '../../../../../common/functions/action/ActionIsAllowedOnIncidents'
import IncidentAssignmentContextMenuPart from '../../../../../common/components/incidentAssignment/incidentAssignmentContextMenuPart'
import CreateIncidentAssignment from '../../../../../common/services/incidentAssignment/incidentAssignmentService'

type ComponentProps = {
  customer: ICustomer
  domain: string
  entityIncidents: IEntityIncident[]
  incidentCollectionRequest: IncidentCollectionRequestType
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
  handleIncidentCollectionChangeRequest: (request:IncidentCollectionRequestType) => void
  handleRefreshApplication: () => void
  handleEntityIncidentsToRemoveChange:(entityIncidents:IEntityIncident[]) => void
  handleIncidentOverviewRequest: () => void
  applicationSettings: null|undefined|IApplicationSettings
}

const IncidentListContextMenu = (props:ComponentProps) => {

  const { instance } = useMsal()

  let allowIncidentCancellationCorrect:boolean = false
  let allowIncidentCancellationIncorrect:boolean = false 
  let allowIncidentAssignment:boolean = false

  if (props.applicationSettings)
  {
    if (props.applicationSettings?.AllowIncidentCancellationCorrect) 
      allowIncidentCancellationCorrect = (Number.parseInt(props.applicationSettings.AllowIncidentCancellationCorrect) !== 0)
    if (props.applicationSettings?.AllowIncidentCancellationIncorrect) 
      allowIncidentCancellationIncorrect = (Number.parseInt(props.applicationSettings.AllowIncidentCancellationIncorrect) !== 0)
    if (props.applicationSettings?.AllowIncidentAssignment) 
      allowIncidentAssignment = (Number.parseInt(props.applicationSettings.AllowIncidentAssignment) !== 0)
  }

  let user = instance.getActiveAccount()
  // TODO: Naming of the action. Multiselect of the action.
  const renderContextMenu:any = (entityIncidents:IEntityIncident[]) => (
    <Popover id='incident-list-context-menu-popover'>
      <Popover.Header className='incident-list-context-menu-popover-header'>handlinger for de valgte emner</Popover.Header>
        <Popover.Body className='incident-list-context-menu-popover-body'>
          {
            props.customer.sense.incidentActions.map(actionDefinition => {
              if (ActionIsAllowedOnIncidents(props.customer, entityIncidents, actionDefinition.name)) 
                return <div key={actionDefinition.name} className='incident-list-context-menu-popover-body-menu-item' onClick={(action) => {handleAction(entityIncidents, actionDefinition)}}>{actionDefinition.displayName}</div>
            })
          }        
          {
            (allowIncidentCancellationCorrect || allowIncidentCancellationIncorrect) &&
            <div className='incident-list-context-menu-popover-body-menu-item'>
              {               
                <IncidentCancellationContextMenuPart 
                  customer={props.customer} 
                  entityIncidents={entityIncidents} 
                  applicationSettings={props.applicationSettings} 
                  handleIncidentCancellation={handleIncidentCancellation} />
              }
            </div>
          }

            {
              (allowIncidentAssignment) &&    
              <div className='incident-list-context-menu-popover-body-menu-item'>
                {
                  <IncidentAssignmentContextMenuPart 
                    customer={props.customer} 
                    domain={props.domain}
                    entityIncidents={entityIncidents} 
                    applicationSettings={props.applicationSettings} 
                    handleIncidentAssignment={handleIncidentAssignment} />
                }
              </div>
            }
      </Popover.Body>
    </Popover>
  )

  const handleAction = (entityIncidents:IEntityIncident[], action:ICustomerIncidentAction) => {
    if (props.entityIncidents) {
    const dialogResponse = window.confirm('Vælg OK hvis du vil gennemføre handlingen ' + action.displayName + ', på de valgte emner.')
    if (dialogResponse) {
        CreateIncidentAction(instance, props.customer.customerID, action, entityIncidents)
        if (action.requestForIncidentRemoval) props.handleEntityIncidentsToRemoveChange(entityIncidents)
      }
    }
    hidePopover('incident-list-context-menu-popover')
  }

  const handleIncidentCancellation = (entityIncidents:IEntityIncident[], reason:string, reasonRemark:string) => {
    if (props.entityIncidents) 
    {
      if (user)
      { 
        CreateIncidentCancellation(instance, props.customer.customerID, user.username, entityIncidents, reason, reasonRemark)
        .then(() => {
          props.handleIncidentOverviewRequest()
          props.handleIncidentCollectionChangeRequest(
          {
            Title: props.incidentCollectionRequest.Title,
            Area: props.incidentCollectionRequest.Area, 
            Value: props.incidentCollectionRequest.Value, 
            Timestamp: new Date()
          })
        })
      }
    }
    hidePopover('incident-list-context-menu-popover')
  }

  
  const handleIncidentAssignment = (entityIncidents:IEntityIncident[], assignToUserID:string, comment:string) => {
    if (user) 
    {
      CreateIncidentAssignment(instance, props.customer.customerID, user.username, entityIncidents, assignToUserID, comment)
      .then(() => {
        props.handleIncidentOverviewRequest()
        props.handleIncidentCollectionChangeRequest(
        {
          Title: props.incidentCollectionRequest.Title,
          Area: props.incidentCollectionRequest.Area, 
          Value: props.incidentCollectionRequest.Value, 
          Timestamp: new Date()
        })
      })
    }
    hidePopover('incident-list-context-menu-popover')
  }
  
  const hidePopover = (popoverID: string) => {
    const popover = document.getElementById(popoverID)
    popover?.style.setProperty('display', 'none')
  }


  return (
    <> 
      <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderContextMenu(props.entityIncidents) }>
        {
          props.entityIncidents && props.entityIncidents.length > 0 ? 
            <div className='incident-list-context-menu'>
              <img className='incident-list-context-menu-image highlight-context-menu' alt='' src={contextMenuImage}></img>
            </div>
          : 
            <div></div>
        }        
      </OverlayTrigger>
    </>
  )
}

export default IncidentListContextMenu
